<template>
  <section class="app-section"
    v-loading.fullscreen="isRequesting"
    element-loading-text="サーバーに問い合わせています">
    <header class="app-header flex justify-between items-center">
      <h2 class="app-h2">管理者専用</h2>
    </header>
    <el-form ref="formThemes" class="px4 py2">
      <h2>Themes</h2>
      <el-input type="textarea" :rows="20" v-model="themesBeautified"></el-input>
      <div class="btn-wrapper flex justify-center items-center mt4">
        <el-button type="primary" round @click="onSubmit('themes')">Update</el-button>
      </div>
    </el-form>
    <el-form ref="formSettings" class="px4 py2">
      <h2>Settings</h2>
      <el-input type="textarea" :rows="20" v-model="settingsBeautified"></el-input>
      <div class="btn-wrapper flex justify-center items-center mt4">
        <el-button type="primary" round @click="onSubmit('settings')">Update</el-button>
      </div>
    </el-form>
  </section>
</template>

<script>
import RouteBase from '@/components/mixins/RouteBase'

export default {
  name: 'Admin',
  mixins: [RouteBase],
  data: function () {
    return {

    }
  },
  computed: {
    themes: {
      get () { return this.$store.getters['wordpress/themes/all'] },
      set (value) { this.$store.commit('wordpress/themes/update', value) }
    },
    settings: {
      get () { return this.$store.getters['wordpress/settings/all'] },
      set (value) { this.$store.commit('wordpress/settings/update', value) }
    },
    themesBeautified: {
      get () { return this.$store.getters['wordpress/themes/json'] },
      set (value) { this.$store.commit('wordpress/themes/update', JSON.parse(value)) }
    },
    settingsBeautified: {
      get () { return this.$store.getters['wordpress/settings/json'] },
      set (value) { this.$store.commit('wordpress/settings/update', JSON.parse(value)) }
    }
  },
  methods: {
    onSubmit: async function (type) {
      let success, response

      this.isRequesting = true

      switch (type) {
        case 'themes':
          response = await this.$store.dispatch('wordpress/themes/update', this.themes)
          success = JSON.stringify(response) === JSON.stringify(this.themes)
          break
        case 'settings':
          response = await this.$store.dispatch('wordpress/settings/update', this.settings)
          success = JSON.stringify(response) === JSON.stringify(this.settings)
          break
        default:
          return false
      }

      if (success) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }

      this.isRequesting = false
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Admin created...')
    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    try { await this.requestSettings() } catch (error) { return false }
    try { await this.requestThemes() } catch (error) { return false }
    this.isRequesting = false
    this.isInitialized = true
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/routes/Admin.vue